import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link } from 'react-router-dom';
import { useTheme, useMediaQuery } from '@mui/material';
import DeleteOutlineOutlinedIcon    from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon   from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon      from '@mui/icons-material/RemoveRedEyeOutlined';
import {
  Box, Typography, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, CircularProgress, Pagination,
  Avatar, TextField, MenuItem, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, IconButton, Checkbox, Tooltip,
  Snackbar, Drawer, Alert,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import SevereColdIcon               from '@mui/icons-material/SevereCold';
import EditNoteIcon                 from '@mui/icons-material/EditNote';
import AssignmentTurnedInIcon       from '@mui/icons-material/AssignmentTurnedIn';
import AddIcon                      from '@mui/icons-material/Add';
import FilterListIcon               from '@mui/icons-material/FilterList';
import RefreshIcon                  from '@mui/icons-material/Refresh';
import SettingsIcon                 from '@mui/icons-material/Settings';
import PersonAddIcon                from '@mui/icons-material/PersonAdd';
import TransferWithinAStationIcon   from '@mui/icons-material/TransferWithinAStation';
import CloseIcon                    from '@mui/icons-material/Close';
import SystemUpdateAltIcon          from '@mui/icons-material/SystemUpdateAlt';
import CheckIcon                    from '@mui/icons-material/Check';
import VisibilityIcon               from '@mui/icons-material/Visibility';
import VisibilityOffIcon            from '@mui/icons-material/VisibilityOff';
import moment                       from 'moment';

import { Get_All_Leads_By_Email_User_Marketer_CRMDATA_email_Action2 } from '../Redux/Actions/UsersAction';
import { Notify }                        from '../Utility/Notify';
import { ClientTable2 }                  from '../Component/ClientTable2';
import { AssignLeadsModal }              from './AssignLeadsModal';
import { ShowClientsActionsAdvanced }    from './ShowClientsActionsAdvanced';
import { LeadDuplicationModal }          from './LeadDuplicationModal';
import QuickFilterModalForMarketer       from './QuickFilterModalForMarketer';
import { useSidebarWidth }               from '../Utility/useSidebarWidth';
import XLSX                              from '../utils/excelUtils';
import axios                             from 'axios';
import { db_url }                        from '../Api/BaseUrl';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

// ─── Tokens ───────────────────────────────────────────────────────────────────
const C = {
  bg:          '#F7F8FC',
  white:       '#FFFFFF',
  border:      '#E8EAF0',
  accent:      '#0D47A1',
  accentDark:  '#1330A6',
  accentSoft:  'rgba(26,62,207,0.07)',
  text:        '#1C2340',
  textMuted:   '#7B829A',
  success:     '#12B76A',
  successSoft: 'rgba(18,183,106,0.08)',
  warning:     '#F79009',
  danger:      '#F04438',
  dangerSoft:  'rgba(240,68,56,0.08)',
  shadow:      '0 1px 3px rgba(16,24,40,0.08)',
};

const SIDEBAR_COLLAPSED = 64;

const StyledRow = styled(TableRow)(() => ({
  '&:hover': { backgroundColor: 'rgba(26,62,207,0.03)' },
  '& td': { borderBottom: `1px solid ${C.border}` },
}));

const StatCard = ({ label, value, badge, highlight }) => (
  <Box sx={{
    bgcolor: highlight ? C.accent : C.white,
    border:  `1px solid ${highlight ? C.accent : C.border}`,
    borderRadius: '12px', p: 2.5,
    width: 160, minWidth: 160, height: 120, minHeight: 120,
    boxShadow: highlight ? '0 4px 16px rgba(26,62,207,0.25)' : C.shadow,
    position: 'relative', overflow: 'hidden', flexShrink: 0,
    display: 'flex', flexDirection: 'column', justifyContent: 'space-between',
  }}>
    {badge && <Box sx={{ position: 'absolute', top: 10, right: 10, bgcolor: C.success, color: '#fff', fontSize: '10px', fontWeight: 700, px: '6px', py: '2px', borderRadius: '20px', fontFamily: "'DM Sans', sans-serif" }}>{badge}</Box>}
    <Typography sx={{ fontSize: '11px', fontWeight: 500, color: highlight ? 'rgba(255,255,255,0.75)' : C.textMuted, letterSpacing: '0.06em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif" }}>{label}</Typography>
    <Typography sx={{ fontSize: '26px', fontWeight: 700, color: highlight ? '#fff' : C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.2 }}>{value != null ? String(value) : '—'}</Typography>
    {highlight && <Box sx={{ height: '3px', width: '40px', bgcolor: '#F79009', borderRadius: '2px' }} />}
  </Box>
);

const ActionBtn = ({ icon, label, onClick, primary, disabled, component, to }) => (
  <Button onClick={onClick} disabled={disabled} startIcon={icon} size="small" component={component} to={to}
    sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: '13px', borderRadius: '8px', textTransform: 'none', px: '14px', py: '7px',
      ...(primary
        ? { bgcolor: C.accent, color: '#fff', border: 'none', boxShadow: '0 2px 8px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark } }
        : { bgcolor: C.white, color: C.text, border: `1px solid ${C.border}`, '&:hover': { bgcolor: C.bg, borderColor: C.accent, color: C.accent } }
      ),
    }}>{label}</Button>
);

const PhoneCell = ({ user }) => {
  const [show, setShow] = useState(false);
  return (
    <Box onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
      <Typography sx={{ fontSize: '13px', color: C.text, mb: '4px' }}>{show ? user.phone : `${(user.phone || '').substring(0, 6)}···`}</Typography>
      <Box sx={{ display: 'flex', gap: '6px' }}>
        <IconButton size="small" onClick={() => window.open(`https://wa.me/${(user.phone || '').replace(/\D/g, '')}`, '_blank')} sx={{ width: 26, height: 26, bgcolor: 'rgba(37,211,102,0.1)', color: '#25D366', '&:hover': { bgcolor: 'rgba(37,211,102,0.2)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
        </IconButton>
        <IconButton size="small" onClick={() => window.open(`tel:${user.phone}`)} sx={{ width: 26, height: 26, bgcolor: 'rgba(26,62,207,0.08)', color: C.accent, '&:hover': { bgcolor: 'rgba(26,62,207,0.15)' } }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
        </IconButton>
      </Box>
    </Box>
  );
};

const ActionsMenu = ({ user, allusers }) => {
  const [anchorEl,    setAnchorEl]    = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [showDelete,  setShowDelete]  = useState(false);
  const open = Boolean(anchorEl);
  const closeMenu = () => setAnchorEl(null);
  return (
    <>
      <ClientTable2 user={user} allusers={allusers} showPreview={showPreview} setShowPreview={setShowPreview} showDelete={showDelete} setShowDelete={setShowDelete} />
      <IconButton size="small" onClick={e => { e.stopPropagation(); setAnchorEl(e.currentTarget); }} sx={{ width: 30, height: 30, borderRadius: '8px', color: C.textMuted, '&:hover': { bgcolor: C.accentSoft, color: C.accent }, transition: 'all 0.15s' }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="12" cy="19" r="1.5"/></svg>
      </IconButton>
      {open && (
        <Box onClick={e => e.stopPropagation()} sx={{ position: 'fixed', top: anchorEl ? anchorEl.getBoundingClientRect().bottom + 4 : 0, left: anchorEl ? Math.min(anchorEl.getBoundingClientRect().left - 160, window.innerWidth - 200) : 0, zIndex: 9999, bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: '0 8px 32px rgba(16,24,40,0.14)', minWidth: 200, py: '6px', overflow: 'hidden' }}>
          <Box onClick={closeMenu} sx={{ position: 'fixed', inset: 0, zIndex: -1 }} />
          <Box sx={{ px: '8px', display: 'flex', flexDirection: 'column', gap: '2px' }}>
            <Box component="a" href={`#/updateclient/${user._id}`} onClick={closeMenu} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, textDecoration: 'none', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: C.accentSoft, color: C.accent } }}>
              <ModeEditOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Edit Lead
            </Box>
            <Box onClick={() => { closeMenu(); setShowPreview(true); }} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.text, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(127,119,221,0.08)', color: '#7F77DD' } }}>
              <RemoveRedEyeOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Preview Lead
            </Box>
            {!window.location.hash.includes('AllLeadsnotactivated') && (
              <>
                <Box sx={{ height: '1px', bgcolor: C.border, mx: '4px', my: '4px' }} />
                <Box onClick={() => { closeMenu(); setShowDelete(true); }} sx={{ display: 'flex', alignItems: 'center', gap: '10px', px: '10px', py: '8px', borderRadius: '8px', color: C.danger, fontSize: '13px', cursor: 'pointer', fontFamily: "'DM Sans', sans-serif", fontWeight: 500, '&:hover': { bgcolor: 'rgba(240,68,56,0.06)' } }}>
                  <DeleteOutlineOutlinedIcon sx={{ fontSize: '17px', color: 'inherit' }} />Delete Lead
                </Box>
              </>
            )}
          </Box>
        </Box>
      )}
    </>
  );
};

const CommentCell = ({ lead }) => {
  const [open, setOpen] = useState(false);
  const lc = lead.lastComment;
  const getInits = (n) => (n || '').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';
  const tooltipContent = !lc ? (
    <Box sx={{ p: 3, textAlign: 'center', bgcolor: '#fff', borderRadius: '16px', minWidth: 200, boxShadow: '0 8px 32px rgba(16,24,40,0.12)', border: '1px solid #E8EAF0' }}>
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="1.5"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
      <Typography sx={{ color: '#7B829A', fontSize: '13px', fontFamily: "'DM Sans', sans-serif", mt: 1 }}>No comments yet</Typography>
    </Box>
  ) : (
    <Box sx={{ width: 380, bgcolor: '#fff', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(16,24,40,0.18)', border: '1px solid #E8EAF0' }}>
      <Box sx={{ px: 3, py: 2, display: 'flex', alignItems: 'center', gap: 2, borderBottom: '1px solid #F0F2F8', bgcolor: '#FAFBFD' }}>
        <Box sx={{ width: 44, height: 44, borderRadius: '50%', bgcolor: '#1A3ECF', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 4px 12px rgba(26,62,207,0.25)' }}>
          <Typography sx={{ color: '#fff', fontSize: '15px', fontWeight: 700, fontFamily: "'DM Sans', sans-serif" }}>{getInits(lc.sales?.name)}</Typography>
        </Box>
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#1C2340', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3, mb: 0.5 }}>{lc.sales?.name || 'Unknown'}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {lc.stage?.name && <Box sx={{ px: '10px', py: '3px', borderRadius: '30px', bgcolor: '#EEF1FD', display: 'flex', alignItems: 'center', gap: '4px' }}><Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#1A3ECF' }}/><Typography sx={{ fontSize: '10px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.06em' }}>{lc.stage.name}</Typography></Box>}
            {lc.firstcomment?.date && <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#7B829A" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg><Typography sx={{ fontSize: '11px', color: '#7B829A', fontFamily: "'DM Sans', sans-serif" }}>{moment(lc.firstcomment.date).format('DD/MM/YYYY h:mm A')}</Typography></Box>}
          </Box>
        </Box>
      </Box>
      {lc.firstcomment?.text && lc.firstcomment.text !== '-' && (
        <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Box sx={{ bgcolor: '#F8F9FF', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #1A3ECF' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1A3ECF" strokeWidth="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg><Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#1A3ECF', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Comment</Typography></Box>
            <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.firstcomment.text}</Typography>
          </Box>
          {lc.secondcomment?.text && lc.secondcomment.text !== '-' && (
            <Box sx={{ bgcolor: '#FFF8F0', borderRadius: '14px', px: 2, py: 1.5, borderLeft: '3px solid #F59E0B' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2"><circle cx="12" cy="12" r="3"/></svg><Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#F59E0B', fontFamily: "'DM Sans', sans-serif", textTransform: 'uppercase', letterSpacing: '0.05em' }}>Next Plan</Typography></Box>
              <Typography sx={{ fontSize: '13px', color: '#2A3458', fontFamily: "'DM Sans', sans-serif", lineHeight: 1.55 }}>{lc.secondcomment.text}</Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
  return (
    <Tooltip open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)} title={tooltipContent} placement="left-start" arrow={false}
      componentsProps={{ tooltip: { sx: { bgcolor: 'transparent', p: 0, m: 0, boxShadow: 'none', border: 'none', maxWidth: 'none', overflow: 'visible' } } }}>
      <Box onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
        <Box sx={{ width: 36, height: 36, borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: lc ? 'rgba(26,62,207,0.08)' : 'rgba(123,130,154,0.08)', color: lc ? '#1A3ECF' : '#7B829A', position: 'relative', transition: 'all 0.2s', '&:hover': { bgcolor: lc ? 'rgba(26,62,207,0.15)' : 'rgba(123,130,154,0.15)', transform: 'scale(1.02)' } }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          {lc && <Box sx={{ position: 'absolute', top: 2, right: 2, width: 8, height: 8, borderRadius: '50%', bgcolor: '#12B76A', border: '1.5px solid #fff' }} />}
        </Box>
      </Box>
    </Tooltip>
  );
};

const DEFAULT_COLS = [
  { key: 'dup',         label: 'Duplicate',    fieldId: 'DUP_STATUS',  w: 110, visible: true },
  { key: 'name',        label: 'Name',         fieldId: 'CLIENT_NAME', w: 200, visible: true },
  { key: 'phone',       label: 'Phone',        fieldId: 'CONTACT_PH',  w: 140, visible: true },
  { key: 'developer',   label: 'Developer',    fieldId: 'DEV_NAME',    w: 130, visible: true },
  { key: 'project',     label: 'Project',      fieldId: 'ASSET_ID',    w: 160, visible: true },
  { key: 'campaign',    label: 'Campaign',     fieldId: 'CAMPAIGN',    w: 150, visible: true },
  { key: 'channel',     label: 'Channel',      fieldId: 'SRC_CHAN',    w: 120, visible: true },
  { key: 'sales',       label: 'Sales',        fieldId: 'SALES_REP',   w: 160, visible: true },
  { key: 'lastComment', label: 'Last Comment', fieldId: 'LAST_CMT',    w: 60,  visible: true },
  { key: 'stage',       label: 'Stage',        fieldId: 'STAGE_ID',    w: 160, visible: true },
  { key: 'createdAt',   label: 'Created',      fieldId: 'CREATE_DT',   w: 140, visible: true },
  { key: 'actions',     label: 'Actions',      fieldId: 'ACT_BTN',     w: 60,  visible: true },
];

const getInitials = (n = '') =>
  (n || '').split(' ').filter(Boolean).map(w => w[0]).join('').toUpperCase().slice(0, 2) || '?';

export const All_Leads_For_Marketer_CRM_Data = () => {
  const isMobile  = useMediaQuery(useTheme().breakpoints.down('md'));
  const dispatch  = useDispatch();
  const location  = useLocation();
  const sidebarW  = useSidebarWidth();

  const [userlogin,      setUserlogin]      = useState(null);
  const [loading,        setLoading]        = useState(true);
  const [currentPage,    setCurrentPage]    = useState(1);
  const [itemsPerPage,   setItemsPerPage]   = useState(25);
  const [searchQuery,    setSearchQuery]    = useState(localStorage.getItem('searchMarketerstorage') || '');
  const [selectedLeads,  setSelectedLeads]  = useState([]);
  const [selectAll,      setSelectAll]      = useState(false);
  const [selectedLead,   setSelectedLead]   = useState(null);
  const [appliedFilters, setAppliedFilters] = useState({});
  const [colConfig,      setColConfig]      = useState(() => {
    try { const s = localStorage.getItem('marketerCRMColConfig'); return s ? JSON.parse(s) : DEFAULT_COLS; } catch { return DEFAULT_COLS; }
  });

  const [showAssign,   setShowAssign]   = useState(false);
  const [quickFilter,  setQuickFilter]  = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [duplication,  setDuplication]  = useState({ open: false, leadId: null, leadName: '' });

  const currentStageRef    = useRef('');
  const pendingRef         = useRef(null);
  const initialLoadDoneRef = useRef(false);

  useEffect(() => { const u = localStorage.getItem('user'); if (u) setUserlogin(JSON.parse(u)); }, []);
  useEffect(() => { localStorage.setItem('marketerCRMColConfig', JSON.stringify(colConfig)); }, [colConfig]);

  const toggleColVisibility = (key) => setColConfig(p => p.map(c => c.key === key ? { ...c, visible: !c.visible } : c));
  const updateColWidth = (key, w) => setColConfig(p => p.map(c => c.key === key ? { ...c, w: Math.max(60, Math.min(400, parseInt(w) || c.w)) } : c));
  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(colConfig);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);
    setColConfig(items);
  };

  const Leads      = useSelector(s => s.AllRoleData.Get_Leads_For_Marketer);
  const leadsData  = Leads?.data || [];
  const pagination = Leads?.pagination || {};

  const extractIds = (items) => {
    if (!items?.length) return '';
    return items.map(i => (typeof i === 'string' ? i : i.id || i._id || i.value || '')).filter(Boolean).join(',');
  };

  const loadLeads = useCallback(async (page = 1, limit = itemsPerPage, search = '', stage = '', dups = '', filters = {}) => {
    if (!userlogin?.data?.email) return;
    setLoading(true);
    let q = `email=${userlogin.data.email}&leadisactive=true&page=${page}&limit=${limit}&sort=-date`;
    if (search) {
      const c = search.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c))    q += `&leadEmail=${encodeURIComponent(c)}`;
      else if (/^[\+]?[0-9\s\-\(\)\.]+$/.test(c))  q += `&phone=${encodeURIComponent(c)}`;
      else                                           q += `&leadName=${encodeURIComponent(c)}`;
    }
    if (stage) q += `&stage=${encodeURIComponent(stage)}`;
    if (dups === 'true') q += `&duplicates=true&ignoreduplicate=true`;
    if (filters && Object.keys(filters).length > 0) {
      ['stage','sales','chanel','campaign','project','developer','oldstage'].forEach(k => {
        if (filters[k]?.length) { const ids = extractIds(filters[k]); if (ids) q += `&${k}=${encodeURIComponent(ids)}`; }
      });
      if (filters.createdAt?.from)        q += `&createdFrom=${encodeURIComponent(filters.createdAt.from)}`;
      if (filters.createdAt?.to)          q += `&createdTo=${encodeURIComponent(filters.createdAt.to)}`;
      if (filters.stagedateupdated?.from) q += `&stageDateFrom=${encodeURIComponent(filters.stagedateupdated.from)}`;
      if (filters.stagedateupdated?.to)   q += `&stageDateTo=${encodeURIComponent(filters.stagedateupdated.to)}`;
      if (filters.budget)                 q += `&budget=${encodeURIComponent(filters.budget)}`;
    }
    try { await dispatch(Get_All_Leads_By_Email_User_Marketer_CRMDATA_email_Action2(q)); }
    catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [userlogin, itemsPerPage, dispatch]);

  useEffect(() => {
    const sp = new URLSearchParams(location.search);
    const stage = sp.get('stage'), dups = sp.get('duplicates'), key = stage || dups || 'all';
    if (currentStageRef.current !== key || !initialLoadDoneRef.current) {
      if (pendingRef.current) clearTimeout(pendingRef.current);
      setCurrentPage(1); currentStageRef.current = key;
      pendingRef.current = setTimeout(() => { loadLeads(1, itemsPerPage, searchQuery, stage, dups, appliedFilters); initialLoadDoneRef.current = true; }, 300);
    }
    return () => { if (pendingRef.current) clearTimeout(pendingRef.current); };
  }, [location.search, searchQuery, appliedFilters, loadLeads]);

  useEffect(() => {
    const handler = () => {
      const v = localStorage.getItem('searchMarketerstorage') || '';
      setSearchQuery(v); setCurrentPage(1);
      const sp = new URLSearchParams(location.search);
      loadLeads(1, itemsPerPage, v, sp.get('stage'), sp.get('duplicates'));
    };
    window.addEventListener('searchMarketerUpdated', handler);
    return () => window.removeEventListener('searchMarketerUpdated', handler);
  }, [itemsPerPage, location.search, loadLeads]);

  const toggleLead = (id) => { const y = window.scrollY; setSelectedLeads(p => p.includes(id) ? p.filter(x => x !== id) : [...p, id]); setTimeout(() => window.scrollTo(0, y), 10); };
  const toggleAll  = () => { const y = window.scrollY; if (selectAll) { setSelectedLeads([]); setSelectAll(false); } else { setSelectedLeads(leadsData.map(l => l._id)); setSelectAll(true); } setTimeout(() => window.scrollTo(0, y), 10); };
  const handleAssign = () => { if (!selectedLeads.length) return; localStorage.setItem('action', 'Assign'); setShowAssign(true); };
  const refresh = () => { setCurrentPage(1); setSelectedLeads([]); setSelectAll(false); const sp = new URLSearchParams(location.search); loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates')); };

  const exportExcel = () => {
    const data = leadsData.map(u => ({ Name: u.name || '', Email: u.email || '', Phone: u.phone || '', Project: u.project?.name || '', Channel: u.chanel?.name || '', Sales: u.sales?.name || '', Stage: u.stage?.name || '', 'Last Comment': u.lastComment?.firstcomment?.text || '', Created: u.createdAt ? moment(u.createdAt).format('DD/MM/YYYY') : '' }));
    const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'CRM Data Leads');
    XLSX.writeFile(wb, `CRM_Data_Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
    Notify('success', `Exported ${data.length} leads`, 'success');
  };
  const exportAllComments = async () => {
    try {
      const response = await axios.get(`${db_url}api/v1/Action`);
      const allActions = response.data.data;
      const data = leadsData.map(lead => {
        const acts = allActions.filter(a => a.leed?._id === lead._id);
        const comments = acts.flatMap(a => a.Comments || []).sort((a, b) => new Date(a.stageDate || a.createdAt) - new Date(b.stageDate || b.createdAt));
        const formatted = comments.map((c, i) => `(${i+1}) [${moment(c.stageDate || c.createdAt).format('DD/MM/YYYY')}] Stage: ${c.stage?.name || 'N/A'} | By: ${c.sales?.name || 'N/A'}\nComment: ${c.firstcomment?.text || ''}\nNext: ${c.secondcomment?.text || ''}`).join('\n\n');
        return { Name: lead.name || '', Phone: lead.phone || '', Sales: lead.sales?.name || '', Stage: lead.stage?.name || '', 'All Comments': formatted || 'No Comments' };
      });
      const ws = XLSX.utils.json_to_sheet(data); const wb = XLSX.utils.book_new(); XLSX.utils.book_append_sheet(wb, ws, 'CRM Leads');
      XLSX.writeFile(wb, `CRM_Data_AllComments_${moment().format('YYYY-MM-DD')}.xlsx`);
      Notify('success', 'Exported with all comments', 'success');
    } catch { Notify('error', 'Export failed', 'error'); }
  };

  // ─── Render Cell ──────────────────────────────────────────────────────────
  const renderCell = (col, lead) => {
    const stageName = lead.stage?.name || '';
    const isPast = lead.stagedateupdated && moment(lead.stagedateupdated).isBefore(moment());

    switch (col.key) {
      case 'dup':
        return (
          <Box onClick={() => setDuplication({ open: true, leadId: lead._id, leadName: lead.name })}
            sx={{ display: 'inline-flex', alignItems: 'center', gap: '5px', px: '10px', py: '4px', borderRadius: '20px', border: `1px solid ${C.border}`, fontSize: '12px', fontWeight: 500, cursor: 'pointer', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", '&:hover': { borderColor: C.accent, color: C.accent } }}>
            <Box component="span" sx={{ width: 22, height: 22, borderRadius: '50%', bgcolor: C.accentSoft, color: C.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: 700 }}>{lead.totalSubmissions || 0}</Box>
            Reg.
          </Box>
        );
      case 'name':
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => setSelectedLead(lead)}>
            <Avatar sx={{ width: 34, height: 34, fontSize: '12px', fontWeight: 700, bgcolor: C.accentSoft, color: C.accent, fontFamily: "'DM Sans', sans-serif" }}>{getInitials(lead.name)}</Avatar>
            <Box>
              <Typography sx={{ fontSize: '13.5px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.3 }}>{lead.name}</Typography>
              <Typography sx={{ fontSize: '12px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.email}</Typography>
            </Box>
          </Box>
        );
      case 'phone': return <PhoneCell user={lead} />;
      case 'developer': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead?.project?.developer?.name || '—'}</Typography>;
      case 'project': return <Typography sx={{ fontSize: '13px', fontWeight: 500, color: C.text, fontFamily: "'DM Sans', sans-serif" }}>{lead.project?.name || '—'}</Typography>;
      case 'campaign': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.campaign?.CampainName || '—'}</Typography>;
      case 'channel': return <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.chanel?.name || '—'}</Typography>;

      // ── Sales — TL badge ──────────────────────────────────────────────────
      case 'sales':
        return (
          <Tooltip
            title={lead.assigntype === true
              ? `Team: ${lead.sales?.name||'N/A'} | Leader: ${lead.sales?.teamleader?.name||'N/A'}`
              : `Team Leader: ${lead.sales?.teamleader?.name||'N/A'}`
            }
            arrow placement="top"
          >
            <Box sx={{ display:'flex', alignItems:'center', gap:'8px', cursor:'default' }}>
              <Avatar sx={{
                width:30, height:30, fontSize:'11px', fontWeight:700, flexShrink:0,
                fontFamily:"'DM Sans',sans-serif",
                bgcolor: lead.assigntype === true ? 'rgba(13,71,161,0.12)' : 'rgba(247,144,9,0.12)',
                color:   lead.assigntype === true ? C.accent : '#B54708',
              }}>
                {lead.assigntype === true ? 'T' : getInitials(lead.sales?.name)}
              </Avatar>
              <Box>
                <Box sx={{ display:'flex', alignItems:'center', gap:'5px' }}>
                  {lead.assigntype === true && (
                    <Box sx={{ fontSize:'9px', fontWeight:800, color:'#fff', bgcolor:C.accent, borderRadius:'4px', px:'4px', py:'1px', lineHeight:1.4, fontFamily:"'DM Sans',sans-serif", letterSpacing:'0.04em' }}>TL</Box>
                  )}
                  <Typography sx={{ fontSize:'13px', fontWeight: lead.assigntype === true ? 700 : 500, color: lead.assigntype === true ? C.accent : C.text, fontFamily:"'DM Sans',sans-serif", lineHeight:1.3 }}>
                    {lead.assigntype === true
                      ? (lead.sales?.teamleader?.name || lead.sales?.name || '—')
                      : (lead.sales?.name || '—')
                    }
                  </Typography>
                </Box>
                {lead.lastdateassign && (
                  <Typography sx={{ fontSize:'11px', color:C.textMuted, fontFamily:"'DM Sans',sans-serif" }}>
                    {moment(lead.lastdateassign).format('DD/MM/YY HH:mm')}
                  </Typography>
                )}
              </Box>
            </Box>
          </Tooltip>
        );

      case 'lastComment': return <CommentCell lead={lead} />;

      // ── Stage — date-based color logic ────────────────────────────────────
      case 'stage':
        return (
          <>
            {stageName && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: lead.stagedateupdated ? '4px' : 0 }}>
                {stageName === 'Done Deal'       ? <span style={{ fontSize: '18px' }}>🎉</span>
                : stageName === 'Pending'        ? <SevereColdIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Fresh'          ? <CheckIcon sx={{ fontSize: '18px', color: '#4caf50', flexShrink: 0 }} />
                : stageName === 'Not Interested' ? <Box sx={{ fontSize: '16px', color: '#fff', borderRadius: '50%', width: '20px', height: '20px', bgcolor: '#555', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, flexShrink: 0 }}>—</Box>
                : stageName === 'EOI'            ? <EditNoteIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Reservation'    ? <AssignmentTurnedInIcon sx={{ color: '#9c27b0', fontSize: '18px', flexShrink: 0 }} />
                : stageName === 'Transfer'       ? <TransferWithinAStationIcon sx={{ color: '#F04438', fontSize: '18px', flexShrink: 0 }} />
                : <Box sx={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0, bgcolor: isPast ? '#CC5500' : C.accent }} />}

                <Box sx={{
                  display: 'inline-flex', alignItems: 'center', px: '8px', py: '3px', borderRadius: '20px',
                  bgcolor:
                    stageName === 'Done Deal'        ? C.successSoft
                    : stageName === 'Pending'        ? 'rgba(156,39,176,0.08)'
                    : stageName === 'Transfer'       ? C.dangerSoft
                    : stageName === 'Not Interested' ? 'rgba(85,85,85,0.08)'
                    : stageName === 'Fresh'          ? 'rgba(76,175,80,0.08)'
                    : isPast ? 'rgba(204,85,0,0.1)' : C.accentSoft,
                  color:
                    stageName === 'Done Deal'        ? C.success
                    : stageName === 'Pending'        ? '#9c27b0'
                    : stageName === 'Transfer'       ? '#F04438'
                    : stageName === 'Not Interested' ? '#555'
                    : stageName === 'Fresh'          ? '#4caf50'
                    : isPast ? '#CC5500' : C.accent,
                }}>
                  <Typography sx={{ fontSize: '11.5px', fontWeight: 600, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>{stageName}</Typography>
                </Box>
              </Box>
            )}
            {lead.stagedateupdated && (
              <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: '2px', display: 'flex', alignItems: 'center', gap: '3px' }}>
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                {moment(lead.stagedateupdated).format('DD/MM/YY HH:mm')}
              </Typography>
            )}
          </>
        );

      case 'createdAt':
        return (
          <>
            <Typography sx={{ fontSize: '13px', color: C.text, fontFamily: "'DM Sans', sans-serif", fontWeight: 500 }}>{lead.createdAt ? moment(lead.createdAt).format('DD/MM/YY') : '—'}</Typography>
            <Typography sx={{ fontSize: '11px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>{lead.createdAt ? moment(lead.createdAt).format('HH:mm') : ''}</Typography>
          </>
        );
      case 'actions':
        return <ActionsMenu user={lead} allusers={() => loadLeads(currentPage, itemsPerPage, searchQuery)} />;
      default: return null;
    }
  };

  return (
    <Box sx={{ ml: isMobile ? `${SIDEBAR_COLLAPSED}px` : `${sidebarW}px`, mt: '64px', minHeight: 'calc(100vh - 64px)', bgcolor: C.bg, transition: 'margin-left 0.25s cubic-bezier(0.4,0,0.2,1)' }}>
      <Box sx={{ p: isMobile ? 2 : 3.5 }}>

        {/* Header */}
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, mb: 3 }}>
          <Box>
            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 800, fontSize: isMobile ? '28px' : '36px', color: C.text, lineHeight: 1.15, letterSpacing: '-0.02em' }}>
              My Data<br />Center
            </Typography>
            <Typography sx={{ fontSize: '13.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", mt: 1, maxWidth: 340 }}>
              Manage and track all leads in the CRM Data Center assigned to you.
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'stretch' }}>
            <StatCard label="Total Leads" value={pagination?.totalItems} badge="+NEW" />
            <StatCard label="This Page"   value={leadsData.length} />
            <StatCard label="Pages"       value={pagination?.NumberOfPages} />
            <StatCard label="Conv. Rate"  value={pagination?.activePercentage != null ? `${pagination.activePercentage}%` : '—'} highlight />
          </Box>
        </Box>

        {/* Table card */}
        <Box sx={{ bgcolor: C.white, borderRadius: '12px', border: `1px solid ${C.border}`, boxShadow: C.shadow, overflow: 'hidden' }}>

          {/* Toolbar */}
          <Box sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', borderBottom: `1px solid ${C.border}` }}>
            <Typography sx={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '16px', color: C.text, flex: 1 }}>CRM Data Pipeline</Typography>
            <Tooltip title="Filter"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setQuickFilter(true)}><FilterListIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Refresh"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={refresh} disabled={loading}><RefreshIcon fontSize="small" /></IconButton></Tooltip>
            <Tooltip title="Table settings"><IconButton size="small" sx={{ color: C.textMuted, '&:hover': { color: C.accent } }} onClick={() => setSettingsOpen(true)}><SettingsIcon fontSize="small" /></IconButton></Tooltip>
            <Box sx={{ width: '1px', height: '20px', bgcolor: C.border }} />
            <ActionBtn icon={<AddIcon />} label="New Lead" primary component={Link} to="/addclient" />
          </Box>

          {/* Table */}
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table size="small" sx={{ minWidth: 700 }}>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: 52, minWidth: 52, py: '10px', px: '12px', borderBottom: `2px solid ${C.border}` }}>
                    <Checkbox size="small" checked={selectAll} onChange={toggleAll} sx={{ color: C.textMuted }} />
                  </TableCell>
                  {colConfig.filter(c => c.visible).map(col => (
                    <TableCell key={col.key} sx={{ width: col.w, minWidth: col.w, py: '10px', px: '12px', fontFamily: "'DM Sans', sans-serif", fontSize: '11.5px', fontWeight: 600, color: C.textMuted, letterSpacing: '0.05em', textTransform: 'uppercase', borderBottom: `2px solid ${C.border}`, whiteSpace: 'nowrap' }}>
                      {col.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}><CircularProgress size={32} sx={{ color: C.accent }} /></TableCell></TableRow>
                ) : !leadsData.length ? (
                  <TableRow><TableCell colSpan={colConfig.filter(c => c.visible).length + 1} align="center" sx={{ py: 6 }}><Typography sx={{ color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>No leads found</Typography></TableCell></TableRow>
                ) : leadsData.map(lead => (
                  <StyledRow key={lead._id}>
                    <TableCell sx={{ px: '12px', py: '10px' }}>
                      <Checkbox size="small" checked={selectedLeads.includes(lead._id)} onChange={() => toggleLead(lead._id)} sx={{ color: C.textMuted, '&.Mui-checked': { color: C.accent } }} />
                    </TableCell>
                    {colConfig.filter(c => c.visible).map(col => (
                      <TableCell key={col.key} sx={{ px: '12px', py: '10px', verticalAlign: 'top', width: col.w, minWidth: col.w, maxWidth: col.w }}>
                        {renderCell(col, lead)}
                      </TableCell>
                    ))}
                  </StyledRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Pagination */}
          {!loading && leadsData.length > 0 && (
            <Box sx={{ px: 2.5, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'center', borderTop: `1px solid ${C.border}`, flexWrap: 'wrap', gap: 1.5, bgcolor: '#ece8e8', position: 'fixed', bottom: 0, borderRadius: '0px 25px 25px 0px', zIndex: 10, boxShadow: '0 -2px 8px rgba(16,24,40,0.06)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", whiteSpace: 'nowrap' }}>Rows per page:</Typography>
                <TextField select value={itemsPerPage} onChange={e => { setItemsPerPage(e.target.value); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, e.target.value, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters); }} size="small" sx={{ width: 72, '& .MuiOutlinedInput-root': { borderRadius: '8px', fontSize: '13px' } }}>
                  {[25, 50, 100, 250].map(n => <MenuItem key={n} value={n} sx={{ fontFamily: "'DM Sans', sans-serif", fontSize: '13px' }}>{n}</MenuItem>)}
                </TextField>
              </Box>
              <Typography sx={{ fontSize: '13px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>
                Showing <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{leadsData.length}</Box> of <Box component="span" sx={{ fontWeight: 700, color: C.text }}>{pagination?.totalItems || leadsData.length}</Box>
              </Typography>
              {pagination?.NumberOfPages > 1 && (
                <Pagination count={pagination.NumberOfPages} page={currentPage} size="small" showFirstButton showLastButton
                  onChange={(_, v) => { setCurrentPage(v); const sp = new URLSearchParams(location.search); loadLeads(v, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                  sx={{ '& .MuiPaginationItem-root': { fontFamily: "'DM Sans', sans-serif", fontSize: '13px', borderRadius: '6px', color: C.textMuted }, '& .Mui-selected': { bgcolor: `${C.accent} !important`, color: '#fff', fontWeight: 700 }, '& .MuiPaginationItem-root:hover': { bgcolor: C.accentSoft } }} />
              )}
            </Box>
          )}
        </Box>
      </Box>

      {/* Snackbar */}
      <Snackbar open={selectedLeads.length > 0} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} message={`${selectedLeads.length} lead(s) selected`}
        action={
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Tooltip title="Assign"><IconButton size="small" onClick={handleAssign} sx={{ color: '#a5d6a7' }}><PersonAddIcon fontSize="small" /></IconButton></Tooltip>
            <Button size="small" onClick={() => { setSelectedLeads([]); setSelectAll(false); }} sx={{ color: '#fff', fontSize: '12px' }}>Clear</Button>
          </Box>
        }
      />

      {/* Modals */}
      {/* {selectedLead && <ShowClientsActionsAdvanced user={selectedLead} leadid={selectedLead._id} onClose={() => setSelectedLead(null)} />} */}
    {selectedLead && (
  <ShowClientsActionsAdvanced
    user={selectedLead}
    leadid={selectedLead._id}
    onClose={() => setSelectedLead(null)}
    onLeadUpdated={() => {
      const sp = new URLSearchParams(location.search);
      loadLeads(currentPage, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), appliedFilters);
    }}
  />
)}
      <LeadDuplicationModal open={duplication.open} onClose={() => setDuplication({ open: false, leadId: null, leadName: '' })} leadId={duplication.leadId} leadName={duplication.leadName} />
      <QuickFilterModalForMarketer open={quickFilter} onClose={() => setQuickFilter(false)} onApplyFilters={f => { setAppliedFilters(f); setCurrentPage(1); const sp = new URLSearchParams(location.search); loadLeads(1, itemsPerPage, searchQuery, sp.get('stage'), sp.get('duplicates'), f); }} />
      {showAssign && <AssignLeadsModal show={showAssign} onHide={() => setShowAssign(false)} selectedLeads={selectedLeads} refreshData={refresh} />}

      {/* Settings Drawer */}
      <Drawer anchor="right" open={settingsOpen} onClose={() => setSettingsOpen(false)} PaperProps={{ sx: { width: 380, bgcolor: '#F4F6FB !important', display: 'flex', flexDirection: 'column' } }}>
        <Box sx={{ px: 2.5, py: 2, bgcolor: C.white, borderBottom: `1px solid ${C.border}`, display: 'flex', alignItems: 'center', gap: 1 }}>
          <IconButton onClick={() => setSettingsOpen(false)} size="small" sx={{ color: C.text, mr: 0.5 }}><CloseIcon fontSize="small" /></IconButton>
          <Typography sx={{ fontWeight: 700, fontSize: '17px', fontFamily: "'DM Sans', sans-serif", color: C.text, flex: 1 }}>Table Settings</Typography>
        </Box>
        <Box sx={{ flex: 1, overflowY: 'auto', scrollbarWidth: 'none' }}>
          <Box sx={{ px: 2.5, pt: 2.5, pb: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {[{ label: 'Export with Last Comment', fn: exportExcel }, { label: 'Export with All Comments', fn: exportAllComments }].map(item => (
              <Box key={item.label} onClick={item.fn} sx={{ display: 'flex', alignItems: 'center', gap: 2, px: 2.5, py: 2, bgcolor: C.accent, borderRadius: '14px', cursor: 'pointer', transition: 'all 0.15s', boxShadow: '0 4px 14px rgba(26,62,207,0.25)', '&:hover': { bgcolor: C.accentDark, transform: 'translateY(-1px)' } }}>
                <Box sx={{ width: 44, height: 44, borderRadius: '10px', bgcolor: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><SystemUpdateAltIcon sx={{ color: '#fff', fontSize: '22px' }} /></Box>
                <Typography sx={{ fontWeight: 700, fontSize: '15px', color: '#fff', fontFamily: "'DM Sans', sans-serif" }}>{item.label}</Typography>
              </Box>
            ))}
          </Box>
          <Box sx={{ px: 2.5, pb: 2 }}>
            <Typography sx={{ fontSize: '12px', fontWeight: 700, color: C.accent, letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: "'DM Sans', sans-serif", mb: 2 }}>Column Order &amp; Visibility</Typography>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="crm-marketer-columns">
                {(provided) => (
                  <Box ref={provided.innerRef} {...provided.droppableProps} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {colConfig.map((col, index) => (
                      <Draggable key={col.key} draggableId={col.key} index={index}>
                        {(provided, snapshot) => (
                          <Box ref={provided.innerRef} {...provided.draggableProps} sx={{ display: 'flex', alignItems: 'center', gap: 1.5, px: 2, py: 1.5, bgcolor: snapshot.isDragging ? '#E8ECFF' : C.white, borderRadius: '14px', border: `1.5px solid ${snapshot.isDragging ? C.accent : C.border}`, boxShadow: snapshot.isDragging ? '0 8px 24px rgba(26,62,207,0.18)' : '0 1px 3px rgba(16,24,40,0.06)', userSelect: 'none' }}>
                            <IconButton size="small" onClick={() => toggleColVisibility(col.key)} sx={{ width: 34, height: 34, borderRadius: '50%', p: 0, flexShrink: 0, color: col.visible ? C.accent : C.textMuted, bgcolor: col.visible ? C.accentSoft : 'rgba(123,130,154,0.08)' }}>
                              {col.visible ? <VisibilityIcon sx={{ fontSize: '17px' }} /> : <VisibilityOffIcon sx={{ fontSize: '17px' }} />}
                            </IconButton>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography sx={{ fontSize: '14px', fontWeight: 600, color: col.visible ? C.text : C.textMuted, fontFamily: "'DM Sans', sans-serif", textDecoration: col.visible ? 'none' : 'line-through' }}>{col.label}</Typography>
                              <Typography sx={{ fontSize: '10.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", letterSpacing: '0.05em', textTransform: 'uppercase' }}>ID: {col.fieldId}</Typography>
                            </Box>
                            <Box sx={{ width: 48, height: 36, bgcolor: '#F0F2F9', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                              <input type="number" value={col.w} onChange={e => updateColWidth(col.key, e.target.value)} onClick={e => e.stopPropagation()} style={{ width: '100%', height: '100%', border: 'none', outline: 'none', background: 'transparent', textAlign: 'center', fontSize: '13px', fontWeight: 600, color: C.text, fontFamily: "'DM Sans', sans-serif" }} />
                            </Box>
                            <Box {...provided.dragHandleProps} sx={{ display: 'flex', flexDirection: 'column', gap: '3px', cursor: 'grab', px: '2px', flexShrink: 0 }}>
                              {[0,1,2].map(r => <Box key={r} sx={{ display: 'flex', gap: '3px' }}>{[0,1].map(c => <Box key={c} sx={{ width: 4, height: 4, borderRadius: '50%', bgcolor: snapshot.isDragging ? C.accent : C.textMuted, opacity: 0.6 }} />)}</Box>)}
                            </Box>
                          </Box>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </Box>
                )}
              </Droppable>
            </DragDropContext>
          </Box>
        </Box>
        <Box sx={{ px: 2.5, py: 2, borderTop: `1px solid ${C.border}`, bgcolor: C.white, display: 'flex', gap: 1 }}>
          <Button fullWidth variant="outlined" onClick={() => setColConfig(DEFAULT_COLS)} sx={{ borderColor: C.border, color: C.textMuted, fontFamily: "'DM Sans', sans-serif", textTransform: 'none', borderRadius: '10px', '&:hover': { borderColor: C.accent, color: C.accent } }}>Reset to Default</Button>
          <Button fullWidth variant="contained" onClick={() => setSettingsOpen(false)} sx={{ bgcolor: C.accent, '&:hover': { bgcolor: C.accentDark }, textTransform: 'none', fontFamily: "'DM Sans', sans-serif", borderRadius: '10px', fontWeight: 600 }}>Done</Button>
        </Box>
      </Drawer>
    </Box>
  );
};
